import React from 'react';
import MypageSolutionWrapper from 'components/MypageSolutionWrapper/MypageSolutionWrapper';

export default function MypageSolutionContainer() {
    return (
        <MypageSolutionWrapper />
    )
}
